
const kv = require('knockout.validation');


kv.localize({
	required: 'заполните',
	min: [
		'введите значение не менее {0}',
		'не менее {0}',
	],
	max: [
		'введите значение не более {0}',
		'не более {0}',
	],
	minLength: [
		'введите не менее {0} символов',
		'не менее {0} символов',
		'не короче {0}',
	],
	maxLength: [
		'введите не более {0} символов',
		'не более {0} символов',
		'не длиннее {0}',
	],

	pattern: 'заполнено неверно',
	email: [
		'проверьте, нет ли опечаток',
		'введите корректный email',
		'исправьте email',
	],
	date: 'введите корректную дату',
	dateISO: 'введите корректную дату',
	number: 'введите число',
	digit: 'введите цифру',
	phoneUS: 'введите корректный номер телефона',
	notEqual: 'выберите другое значение',
	equal: 'выберите другое значение',
});
